import ApplicationState from '../store/ApplicationState';

import { getSelectors } from '../lib/selectorCreator';
import { ActivatedReferralTrigger, LocationReferralTrigger, ReferralMeta } from '../../../types/referrals.type';
import { createSelector } from 'reselect';

const referralMetadataState = (state: ApplicationState) => state.submissionReferralMetadata;
const triggers = (state: ReferralMeta) => {
    return state.referralTriggers;
};
const triggersByReason = (state: Record<number, LocationReferralTrigger>) => {
    // this is organized by locationId, need to flip to to organize by reason
    const ret = {} as Record<string, (ActivatedReferralTrigger & { locationName: string })[]>;
    for (const locationReferral of Object.values(state)) {
        for (const referralTrigger of locationReferral.activatedTriggers) {
            if (!(referralTrigger.triggerReason in ret)) {
                ret[referralTrigger.triggerReason] = [];
            }
            ret[referralTrigger.triggerReason].push({
                ...referralTrigger,
                locationName: locationReferral.locationName,
            });
        }
    }
    return ret;
};

export const getLocationReferralTriggerByReason = (locationId?: number) => (state: ApplicationState) => {
    const triggerState = state?.submissionReferralMetadata?.data?.referralTriggers;
    if (!locationId && triggerState) {
        // no locationId means we want everything
        return triggersByReason(triggerState);
    }
    if (triggerState && locationId && locationId in triggerState) {
        const s = {}; // only want the Triggers for that location to flatten
        s[locationId] = triggerState[locationId];
        return triggersByReason(s);
    }
    return undefined;
};

const selectors = getSelectors(referralMetadataState);

export const getReferralMetadataLoading = selectors.getLoading;
export const getReferralMetadataError = selectors.getError;
export const getReferralMetadataData = selectors.getData;
export const getReferralMetadataHasResolved = selectors.getHasResolved;
export const getReferralTriggers = createSelector(getReferralMetadataData, triggers);
export const getReferralTriggerByReason = createSelector(getReferralTriggers, triggersByReason);
